export default __webpack_public_path__ + "img/plus.9b8f5034.svg";